const fonts = {
  body: "'Inter', sans-serif",
  heading: "'DM Serif Display', serif",
};

export default fonts;
